import * as React from "react";
/* empty css                        */
const ProductBlockHeader = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-header" }, children);
};
export {
  ProductBlockHeader
};
//# sourceMappingURL=ProductBlockHeader.js.map
